export default "__VITE_ASSET__8529ec0e__"